import { HttpRequest } from "@/utils/request"

export type SetSearchLogAction = "click" | "blur" | "enter"

export interface SetSearchLogItem {
  id: number
  query: string
  results_count: number
  action: SetSearchLogAction
  selected_set_id?: number | null
  selected_set_title?: string | null
  selected_index?: number | null
  user_id?: number | null
  user_agent?: string | null
  ip_address?: string | null
  latency_ms?: number | null
  created_at: string
  user?: {
    id: number
    name: string
    email: string
    username: string
    avatar?: string
    is_test?: number
  } | null
  selected_set?: {
    id: number
    title: string
    slug: string
    type: "system" | "user"
    node_type: "folder" | "set"
  } | null
}

export interface SetSearchLogStats {
  total: number
  click_count: number
  blur_count: number
  enter_count: number
  no_results_count: number
  guest_count: number
  member_count: number
  ctr_percentage: number
}

export interface SetSearchLogQueryParams {
  page?: number
  limit?: number
  start_date?: string
  end_date?: string
  query?: string
  action?: SetSearchLogAction | ""
  has_results?: "yes" | "no" | ""
  user_type?: "all" | "logged_in" | "guest" | ""
  user_search?: string
  user_id?: number
}

export interface SetSearchLogListResponse {
  code: number
  data: SetSearchLogItem[]
  total: number
  page: number
  limit: number
  stats: SetSearchLogStats
}

export const setSearchLogService = {
  list(params: SetSearchLogQueryParams) {
    return HttpRequest.get("v1/set-search-logs", {
      searchParams: params as Record<string, string | number | undefined>,
    }).json<SetSearchLogListResponse>()
  },
}
